var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX1 = function SvgX1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M22.905 9v11.98H20.84v-9.444l-2.734.952V10.73L22.671 9zM8.23 19.324 7 18.061l6.066-6.524 1.23 1.272zm4.852 0L7.016 12.81l1.222-1.272 6.067 6.524z"
  })));
};
export default SvgX1;